import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../../service/api.service';
import { QuickviewService } from '../../../../services/quickview.service';
import { ApplyNowCourseComponent } from '../apply-now-course/apply-now-course.component';
declare var $: any;

@Component({
  selector: 'app-home-page-filter',
  templateUrl: './home-page-filter.component.html',
  styleUrls: ['./home-page-filter.component.scss']
})
export class HomePageFilterComponent implements OnInit {

  constructor(
      private route : ActivatedRoute,
      private service : ApiService,
      private router :  Router,
      private quickview: QuickviewService,
      private cd: ChangeDetectorRef,
      private dialog: MatDialog


  ) { }
  categorySlug = this.route.snapshot.paramMap.get('categorySlug');
  subCategorySlug = this.route.snapshot.paramMap.get('subCategorySlug');
  uniqueCourseSlug = this.route.snapshot.paramMap.get('uniqueCourseSlug');
  datas:any;
  ngOnInit(): void {
    this.loadData();
  }
  showingQuickview = false;

  loadData(){
      if(this.categorySlug && this.subCategorySlug && this.uniqueCourseSlug){
        this.service.getHomePageFilter(this.categorySlug, this.subCategorySlug, this.uniqueCourseSlug).subscribe((res:any) => {
            console.log(res)
            this.datas = res;
        })
      }else{
          this.router.navigate(['**'])
      }

  }
  apply(data){

}
  showModal(data):void {
    const dialogRef = this.dialog.open(ApplyNowCourseComponent, {
        data: data,
    });
  }
  sendModal(): void {
  }
  hideModal():void {
  }


}
